/**
 * Indicates the environment that checkout window is in.
 */
export function isDevEnvironment(baseUrl: string): boolean {
	return baseUrl === 'https://dev.peachpay.app/'
		|| baseUrl === 'https://dev.peachpay.local/'
		|| baseUrl === 'https://prod.peachpay.local/';
}

/**
 * Gets the base url for the PeachPay API server.
 */

export function getBaseURL(merchantHostname: string, isTestMode: boolean): string {
	const address = new URL('https://' + merchantHostname);
	merchantHostname = address.host + (address.pathname === '/' ? '' : address.pathname);
	if (isTestMode) {
		switch (merchantHostname) {
			case 'store.local':
			case 'woo.store.local':
				return 'https://dev.peachpay.local/';
			default:
				return 'https://dev.peachpay.app/';
		}
	}

	switch (merchantHostname) {
		case 'localhost':
		case '127.0.0.1':
		case 'woo.peachpay.app':
		case 'theme1.peachpay.app':
		case 'theme2.peachpay.app':
		case 'theme3.peachpay.app':
		case 'theme4.peachpay.app':
		case 'theme5.peachpay.app':
		case 'qa.peachpay.app':
		case 'demo.peachpay.app':
		case 'ui-test.peachpay.app':
			return 'https://dev.peachpay.app/';
		case 'store.local':
		case 'woo.store.local':
			return 'https://prod.peachpay.local/';
		default:
			return 'https://prod.peachpay.app/';
	}
}

export function getOneClickURL(merchantHostname: string, isTestMode: boolean): string {
	if (isTestMode) {
		switch (merchantHostname) {
			case 'store.local':
			case 'woo.store.local':
				return 'https://dev-connect.peachpay.local/';
			default:
				return 'https://dev-connect-v2.peachpaycheckout.com/';
		}
	}

	switch (merchantHostname) {
		case 'localhost':
		case '127.0.0.1':
		case 'woo.peachpay.app':
		case 'theme1.peachpay.app':
		case 'theme2.peachpay.app':
		case 'theme3.peachpay.app':
		case 'theme4.peachpay.app':
		case 'theme5.peachpay.app':
		case 'qa.peachpay.app':
		case 'demo.peachpay.app':
		case 'ui-test.peachpay.app':
			return 'https://dev-connect-v2.peachpaycheckout.com/';
		case 'store.local':
		case 'woo.store.local':
			return 'https://connect.peachpay.local/';
		default:
			return 'https://connect-v2.peachpaycheckout.com/';
	}
}

export function determinePageType(isCartPage: boolean, isCheckoutPage: boolean, isShopPage: boolean): 'product' | 'cart' | 'checkout' | 'shop' {
	if (isCartPage) {
		return 'cart';
	}

	if (isCheckoutPage) {
		return 'checkout';
	}

	if (isShopPage) {
		return 'shop';
	}

	return 'product';
}
